import { Injectable } from '@angular/core';
import { HttpEvent, HttpRequest, HttpResponse, HttpInterceptor, HttpHandler } from '@angular/common/http';

import { tap } from 'rxjs/operators';

import { RequestCache } from '../services/request-cache.service';
import { Observable, of } from 'rxjs';

@Injectable()
export class CachingInterceptor implements HttpInterceptor {
  constructor(private cache: RequestCache) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    const cacheControl = req.headers.get('Cache-Control');
    const cacheRequest = !(cacheControl && cacheControl.includes('no-cache'));
    const cachedResponse = this.cache.get(req);
    return cachedResponse ? of(cachedResponse) : this.sendRequest(req, next, this.cache, cacheRequest);
  }

  sendRequest(
    req: HttpRequest<unknown>,
    next: HttpHandler,
    cache: RequestCache,
    cacheRequest: boolean
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse && cacheRequest) {
          cache.put(req, event);
        }
      })
    );
  }
}
